'use client'
import React, { useState, useEffect } from 'react'
import { VARIANT } from '@/src/utils/buildUtils'
import { CLEARTRIP } from '@/src/constants/buildVariants'
import FlyinHeaderContainer from '../flyinHeader'
import CTHeaderContainer from '../ctHeader'
import { domainCountry } from '@/src/constants/domain'

const HeaderContainer: React.FC = () => {
    const [isClient, setIsClient] = useState(false)

    useEffect(() => {
        setIsClient(true)
    }, [])

    // Show FlyinHeader for FEG and FSA domains, CTHeader for all others
    const showFlyinHeader = domainCountry === 'FEG' || domainCountry === 'FSA' || domainCountry === 'FAE'
    const HeaderComponent = showFlyinHeader ? FlyinHeaderContainer : CTHeaderContainer

    // During SSR and initial hydration, always render CTHeader to prevent mismatch
    if (!isClient) {
        return <FlyinHeaderContainer />
    }

    return <HeaderComponent />
}

export { HeaderContainer }
export default HeaderContainer
